"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPersistenceType = isPersistenceType;
function isPersistenceType(value) {
    return ['cookie', 'localStorage'].includes(value);
}
//# sourceMappingURL=config.js.map